module.exports = __webpack_public_path__ + "img/toggle-right.6a82b4b1.svg";